import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ navigationItems = ['Home', 'Orders'] }) => {
  const navigate = useNavigate();

  // Example login check function — adjust as needed
  const isLoggedIn = () => {
    // You can replace this logic with your actual auth check
    // For example, check localStorage, context, or a Redux store
    return !!localStorage.getItem('authToken');
  };

  const handleNavigation = (index, item) => {
    const itemName = item.toLowerCase();

    if (index === 0) {
      navigate('/');
    } else if (itemName === 'profile') {
      if (isLoggedIn()) {
        navigate('/profile');
      } else {
        navigate('/login');
      }
    } else if (itemName === 'orders') {
      navigate('/profile/orders');
    } else if (itemName === 'purchases') {
      navigate('/profile/purchases');
    } else if (itemName === 'subscription plan') {
      navigate('/profile/subscription');
    } else if (itemName === 'my address') {
      navigate('/profile/address');
    } else if (itemName === 'settings') {
      navigate('/profile/settings');
    } else if (itemName === 'share app') {
      navigate('/profile/share');
    } else if (itemName === 'wishlist') {
      navigate('/wishlist');
    }
  };

  return (
    <nav
      className="flex flex-col justify-center items-start px-4 py-2.5 mt-6 w-full text-base text-center whitespace-nowrap bg-white rounded-xl shadow-2xl max-w-[1140px] max-md:max-w-full"
      aria-label="Breadcrumb navigation"
    >
      <ol className="flex gap-1.5 justify-center items-center">
        {navigationItems.map((item, index) => (
          <React.Fragment key={index}>
            <li className="flex gap-2.5 items-start self-stretch my-auto">
              {index === navigationItems.length - 1 ? (
                <span className="text-zinc-500" aria-current="page">
                  {item}
                </span>
              ) : (
                <button
                  onClick={() => handleNavigation(index, item)}
                  className="text-yellow-500 hover:underline focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50 rounded transition-colors duration-200"
                >
                  {item}
                </button>
              )}
            </li>
            {index < navigationItems.length - 1 && (
              <li>
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/8dd36cc4300533b24e71b89aa3e0f9841027c920?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
                  alt=""
                  className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
                  role="presentation"
                />
              </li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
